import { Link as RouterLink, Outlet } from 'react-router-dom';

// @mui
import { styled } from '@mui/material/styles';
import { Box, Container } from '@mui/material';
import { m } from 'framer-motion';
import { MotionContainer, varFade } from '../components/animate';

// components
// import Logo from '../components/Logo';

// ----------------------------------------------------------------------

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0),
  },
}));

// ----------------------------------------------------------------------

export default function LogoOnlyLayout() {
  return (
    <>
      <HeaderStyle>
        <Container component={MotionContainer} sx={{ position: 'relative', height: '100%' }}>
          <m.div variants={varFade().inLeft}>
            <RouterLink to="/">
              <Box sx={{ width: 40, height: 40 }}>
                <img src="/logo/peerxiv_logo.png" alt="logo" />
              </Box>
            </RouterLink>
          </m.div>
        </Container>
        {/* <Logo /> */}
      </HeaderStyle>
      <Outlet />
    </>
  );
}
